import { useQuery } from "@tanstack/react-query";
import {
  ApplicationFeatureFunctionalityDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_COMPANIES } from "../domain";

import { applicationFeatureFunctionalityApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_APPLICATION_FEATURE_FUNCTIONALITIES =
  "GET_APPLICATION_FEATURE_FUNCTIONALITIES";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getApplicationFeatureFunctionalities = async (): Promise<
  ApplicationFeatureFunctionalityDto[]
> => {
  const response =
    await applicationFeatureFunctionalityApi.applicationFeatureFunctionalityControllerGetApplicationFeatureFunctionalities();

  return response.data;
};

export const useGetApplicationFeatureFunctionalities = (
  user: UserProfileDto | null,
): {
  applicationFeatureFunctionalities?: ApplicationFeatureFunctionalityDto[];
  isPendingGetApplicationFeatureFunctionalities: boolean;
  applicationFeatureFunctionalitiesEnabled: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);

  const { data, isPending } = useQuery({
    queryKey: [DOMAIN_COMPANIES, ACTION_GET_APPLICATION_FEATURE_FUNCTIONALITIES],
    queryFn: () => getApplicationFeatureFunctionalities(),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    applicationFeatureFunctionalities: data,
    isPendingGetApplicationFeatureFunctionalities: isPending,
    applicationFeatureFunctionalitiesEnabled: enabled,
  };
};
